export const social = {
    git: "https://github.com/Dave3130",
    linkedIn: "https://www.linkedin.com/in/dave-jaydeep/",
    insta: "https://www.instagram.com/davejaydeep48/",
    gmail: "davejaydeep48@gmail.com",
    codechef: "https://www.codechef.com/users/dave31",
    hackerrank: "https://www.hackerrank.com/davejaydeep48",
    stopstalk: "https://www.stopstalk.com/user/profile/Dave31",
}

export const exp = [
    {
        id: 1,
        title: "CDAC",
        role: "Mahine Learning Intern",
        time: "Jan 2020 - Present",
        logo: require('../assest/icons/CDAC.png'),
        description: "Working as an intern in a team of 3, we researched and developed an anti-spoof model for CDAC's attendance management system. By making use of image processing and Machine Learning technologies in Python, the prototype of the system was built. Creating our own customized dataset, data analysis, face detection, model training with neural networks was all a part of very effective learning and developing. This experience greatly influenced my technical skills as we worked on a project that helped us go beyond the scope of academic learning.",
        img: require('../assest/img/exp1.png')

    },
    {
        id: 2,
        title: "CODEYANTRA",
        role: "Head of Committee",
        time: "Aug 2019 - Aug 2020",
        logo: require('../assest/icons/codeyantra_logo.jpeg'),
        description: "Being the Head of our college's Coding Committee- 'CodeYantra', I made sure to give every student an opportunity to develop their coding skills by conducting weekly coding challenges, seminars, workshops as well as scheduling and partaking in various doubt solving sessions and classes like Data structures and Algorithms. Further, I also had the responsibility of maintaining the official website of Codeyantra which includes backend management along with keep the social profiles of the committee updated. This experience helped me develop my own skills as I helped other students as well. It also helped me in gaining a strong hold on my leadership skills.",
        img: require('../assest/img/exp2.png')

    },
    {
        id: 3,
        title: "SLRTCE",
        role: "Web Developer",
        time: "Dec 2019 - Jan 2020",
        logo: require('../assest/icons/slrtce.png'),
        description: "Leading a team of 5 and working as an intern in web development, we designed and developed our college's official coding committee 'CodeYantra' from scratch. Everything- from User experience, graphics design up to backend database connectivity was built. Along with other features, the website has a simplified selection process for future team member that automates almost as much as 80% of the process.This experience helped me gain firsthand experience in Web Development as well as improved my teamwork capabilities.",
        img: require('../assest/img/exp3.png')

    }
]


export const openSource = {
    githubUserName: "Dave3130",
    showGithubProfile: "true"
};

export const skills = [
    {
        id: 1,
        img: "reactjs",
        name: "React.js"
    },
    {
        id: 2,
        img: "javascript",
        name: "Javascript"
    },
    {
        id: 3,
        img: "html",
        name: "HTML5"
    },
    {
        id: 4,
        img: "css",
        name: "CSS3"
    },
    {
        id: 5,
        img: "jquery",
        name: "Jquery"
    },
    {
        id: 6,
        img: "php",
        name: "Php"
    },
    {
        id: 7,
        img: "sql",
        name: "Sql"
    },
    {
        id: 8,
        img: "graphql",
        name: "Graphql"
    },
    {
        id: 9,
        img: "nodejs",
        name: "Node.js"
    },
    {
        id: 10,
        img: "npm",
        name: "Npm"
    },
    {
        id: 11,
        img: "python",
        name: "Python"
    },
    {
        id: 12,
        img: "java",
        name: "Java"
    },
]

export const tools = [
    {
        id: 1,
        img: "vscode",
        name: "VS Code"
    },
    {
        id: 2,
        img: "brackets",
        name: "Brackets"
    },
    {
        id: 3,
        img: "adobe-xd",
        name: "Adobe XD"
    },
    {
        id: 4,
        img: "figma",
        name: "Figma"
    },
    {
        id: 5,
        img: "bootstrap",
        name: "Bootstrap"
    },
    {
        id: 6,
        img: "material-ui",
        name: "Material UI"
    },
    {
        id: 7,
        img: "git",
        name: "Git"
    },
]

export const interests = [
    {
        id: 1,
        img: "coding",
        name: "Competitive Coding"
    },
    {
        id: 2,
        img: "DataScience",
        name: "Data Science"
    },
    {
        id: 3,
        img: "ML",
        name: "Machine Learning"
    },
    {
        id: 4,
        img: "IoT",
        name: "Internet of Things(IoT)"
    },
]

export const certificates = [
    {
        id: 1,
        title: "Front-End Engineer Career Path",
        icon: "Codecademy.png",
        date: "Nov 2020",
        url: "https://www.codecademy.com/profiles/Dave3130/certificates/5f85dd867b67b60014ac9ea3",
    },
    {
        id: 2,
        title: "Learn React.js: Part I Course",
        icon: "Codecademy.png",
        date: "April 2020",
        url: "https://www.codecademy.com/profiles/py7013155471/certificates/af00e5032d0a68cc84879983f5d8333b",
    },
    {
        id: 3,
        title: "Front-End Web UI Frameworks and Tools: Bootstrap 4",
        icon: "Coursera.jpg",
        date: "Nov 2020",
        url: "https://www.coursera.org/account/accomplishments/certificate/N6KRR6LCE9TJ",
    },
    {
        id: 4,
        title: "MTA: Introduction to Programming Using JavaScript - Certified 2019",
        icon: "Microsoft.png",
        date: "Oct 2019",
        url: "https://www.youracclaim.com/badges/8ffe4e30-5c84-429c-9f6c-a4269b4943cb/linked_in_profile",
    },
    {
        id: 5,
        title: "Advance Python",
        icon: "Coursera.jpg",
        date: "Sept 2019",
        url: "https://www.coursera.org/account/accomplishments/certificate/Z6ADP97NCABV",
    },
    {
        id: 6,
        title: "Python for Data Science",
        icon: "IBM-cognitive.png",
        date: "July 2019",
        url: "https://www.youracclaim.com/badges/20d6696b-b276-4b60-9379-6d69fa110374/linked_in_profile",
    }
]

export const blogs = [
    {
        id: 1,
        title: "If there is no reference point, be the one",
        img: require('../assest/img/blog-1.jpg'),
        url: "https://jd3130.blogspot.com/2018/03/there-is-no-refernce-point-be-one_27.html"
    },
    {
        id: 2,
        title: "Zero To Hero",
        img: require('../assest/img/blog-2.jpg'),
        url: "https://jd3130.blogspot.com/2018/07/zero-to-hero.html"
    },
]